// Test ID domain constants
// See docs/designConcepts/test-id-convention.md for naming conventions

export const TestIdDomain = {
  ACTIVITIES: 'activities',
  CONSTRUCTION: 'construction',
  ACCOUNTING_SETTINGS: 'accounting-settings',
  ACTIVE_APPLICANTS: 'active-applicants',
  ADJUSTMENTS: 'adjustments',
  AI_CHAT: 'ai-chat',
  ANALYTICS: 'analytics',
  APPLY_FORM_CUSTOM_QUESTIONS: 'apply-form-custom-questions',
  APPRAISAL_PRODUCT_CRITERIA: 'appraisal-product-criteria',
  APPRAISAL_PRODUCT_PRICING: 'appraisal-product-pricing',
  APPRAISAL_PRODUCTS: 'appraisal-products',
  APPRAISAL_SURCHARGE_CRITERIA: 'appraisal-surcharge-criteria',
  APPRAISAL_SURCHARGES: 'appraisal-surcharges',
  AUDIO_RECORDINGS: 'audio-recordings',
  AUTO_LOCK_RULES: 'auto-lock-rules',
  AUTOMATED_ACTION_CRITERIA: 'automated-action-criteria',
  BORROWERS: 'borrowers',
  BORROWER_VESTING_TYPES: 'borrower-vesting-types',
  BROKERS: 'brokers',
  BUSINESS_DAYS: 'business-days',
  BUY_DOWNS: 'buy-downs',
  CALCULATION_FIELDS: 'calculation-fields',
  CATEGORY_MANAGER: 'category-manager',
  CHANNELS: 'channels',
  CHAT_ESCALATION: 'chat-escalation',
  CHECKLISTS: 'checklists',
  CIC_REASONS: 'cic-reasons',
  CLAIMS_CONFIGURATION: 'claims-configuration',
  CLOSING_PORTAL: 'closing-portal',
  COMMAND_CENTER_HOME: 'command-center-home',
  COMMAND_CENTER_LAYOUT_BUILDER: 'command-center-layout-builder',
  COMMON: 'common',
  COMPANIES: 'companies',
  CONDITION_CATEGORIES: 'condition-categories',
  CONDITION_SETS: 'condition-sets',
  CONDITIONS: 'conditions',
  CONTACT_ACTIVITIES: 'contact-activities',
  CONTACT_DETAIL: 'contact-detail',
  CONTACT_LIST: 'contact-list',
  CSV_MAPPINGS: 'csv-mappings',
  CUSTOM_ADJUSTMENTS: 'custom-adjustments',
  DEALERS: 'dealers',
  DENIAL_REASONS: 'denial-reasons',
  DIALOGS: 'dialogs',
  DRIP_CAMPAIGNS: 'drip-campaigns',
  DOCUMENT: 'document',
  DOCUMENT_BUNDLES: 'document-bundles',
  DOCUMENT_EXTRACTION_FIELDS: 'document-extraction-fields',
  DOCUMENT_EXTRACTION_FIELDS_MAPPING: 'document-extraction-fields-mapping',
  DOCUMENT_FIELD_TYPES: 'document-field-types',
  DOCUMENT_TYPES: 'document-types',
  DOCUMENTS: 'documents',
  DOMAINS: 'domains',
  ELIGIBILITY_BUILDER: 'eligibility-builder',
  EMAIL_NOTIFICATIONS: 'email-notifications',
  ENTITY_AUDIT_HISTORY: 'entity-audit-history',
  ESCROW_REQUIREMENTS: 'escrow-requirements',
  EXCEPTION_SUB_CATEGORIES: 'exception-sub-categories',
  EXCEPTION_TRACKING_REPORT: 'exception-tracking-report',
  FEE_PROVIDERS: 'fee-providers',
  FILTERS_FORM: 'filters-form',
  FINANCIAL_INFO: 'financial-info',
  FORM_GENERATOR: 'form-generator',
  FORMS: 'forms',
  GUIDELINES: 'guidelines',
  HEADER_VIEWS: 'header-views',
  HOMEVISION_JOB_TYPES: 'homevision-job-types',
  IMPOUND_TYPES: 'impound-types',
  INVESTORS: 'investors',
  LEAD_WORKSPACE: 'lead-workspace',
  LLPA_CAP: 'llpa-cap',
  LLPA_TYPES: 'llpa-types',
  LOAN: 'loan',
  LOAN_ACTIONS: 'loan-actions',
  LOAN_HEADERS: 'loan-headers',
  LOAN_CLOSING: 'loan-closing',
  LOAN_FEES: 'loan-fees',
  LOAN_HEADER_VIEW_BUILDER: 'loan-header-view-builder',
  LOAN_MANAGEMENT: 'loan-management',
  LOAN_NUMBER: 'loan-number',
  LOAN_PARTIES: 'loan-parties',
  LOAN_PIPELINES: 'loan-pipelines',
  LOAN_PROGRESS_MILESTONES: 'loan-progress-milestones',
  LOAN_TAGS: 'loan-tags',
  LOAN_ROLES: 'loan-roles',
  LOANS_TABLE: 'loans-table',
  MARGIN_CENTER_CONSOLE: 'margin-center-console',
  MARGIN_CENTER_GUARDRAILS: 'margin-center-guardrails',
  MARGIN_CENTER_PREVIEW: 'margin-center-preview',
  MARGIN_CENTER_RATE_SHEET_DRAWER: 'margin-center-rate-sheet-drawer',
  MARGIN_CENTER_RATE_SHEET_SOURCE: 'margin-center-rate-sheet-source',
  MARGIN_CENTER_RATE_SHEET_UPLOAD: 'margin-center-rate-sheet-upload',
  MARGIN_CENTER_RAIL: 'margin-center-rail',
  MARGIN_CENTER_RULES: 'margin-center-rules',
  MARGIN_CENTER_SETTINGS: 'margin-center-settings',
  MARKET_TO_MARKET: 'market-to-market',
  MI_COVERAGE_CRITERIA: 'mi-coverage-criteria',
  MI_RULES: 'mi-rules',
  MSR: 'msr',
  NEW_CONTACT: 'new-contact',
  NOTIFICATION_DISPATCHER: 'notification-dispatcher',
  PIPELINES: 'pipelines',
  POST_CLOSING: 'post-closing',
  POST_CLOSING_OPTIONS: 'post-closing-options',
  PRESENCE: 'presence',
  PRIOR_TO_TYPES: 'prior-to-types',
  PROGRAM_IDENTIFIERS: 'program-identifiers',
  PROGRAM_INDEX_TYPES: 'program-index-types',
  PROFILE: 'profile',
  PROGRAM_MAPPING: 'program-mapping',
  PROGRAMS: 'programs',
  PROGRAMS_AND_PRICING: 'programs-and-pricing',
  PROGRAMS_MAPPER: 'programs-mapper',
  PROPERTIES: 'properties',
  PROPERTY_AND_LOAN: 'property-and-loan',
  PROPERTY_DEFINITIONS: 'property-definitions',
  RATE_LOCK_TERMS: 'rate-lock-terms',
  REALTORS: 'realtors',
  RECORDING_REQUIREMENTS: 'recording-requirements',
  ROLE_RESTRICTIONS: 'role-restrictions',
  ROLES: 'roles',
  RULES: 'rules',
  SLA_GROUPS: 'sla-groups',
  SEARCH_SYNONYMS: 'search-synonyms',
  SELLER_ADJUSTMENT_TYPES: 'seller-adjustment-types',
  SERVICING_COMPANIES: 'servicing-companies',
  SETTINGS: 'settings',
  SNACKBAR: 'snackbar',
  DOCUMENT_EXPIRATION_SETTINGS: 'document-expiration-settings',
  SUB_COMPANIES: 'sub-companies',
  TAGS: 'tags',
  TASK_CATEGORIES: 'task-categories',
  TASKS: 'tasks',
  TPO_DENIAL_CONFIGURATION: 'tpo-denial-configuration',
  TPO_STATUS_CONFIGURATION: 'tpo-status-configuration',
  TRUSTEES: 'trustees',
  TURN_TIME_DEFINITIONS: 'turn-time-definitions',
  UNDERWRITING: 'underwriting',
  USERS: 'users',
  VENDOR_REQUESTS: 'vendor-requests',
  WEBHOOKS: 'webhooks',
  WHITELIST: 'whitelist',
  IP_WHITELIST: 'ip-whitelist',
};
